import { type ReactNode, type MouseEventHandler } from 'react';
import { Image } from 'components';
import { makeStyles } from '@mui/styles';
import { type Theme, Grid } from '@mui/material';
import { type GridSize } from '@mui/material/Grid/Grid';
import { useSelectedLinkContext } from 'contexts';
import {useFormatMessage} from 'hooks';

const useStyles = makeStyles((theme: Theme) => ({
  menuCategory: {
    position: 'relative'
  },
  image: {
    height: '100%',
    maxWidth: 600,
    transform: 'scale(0.95)',
    transition: 'all .2s ease-in-out',

    '&:hover': {
      transform: 'scale(1)',
    },

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}), { name: 'MenuCategory' });

export type MenuCategoryProps = {
  altId: string;
  enableEvenIfNoSelectedLink?: boolean;
  image: string;
  md: GridSize;
  onClick?: MouseEventHandler;
  onMouseOver?: MouseEventHandler;
  children?: ReactNode;
};

const MenuCategory = ({ children, altId, image, md, enableEvenIfNoSelectedLink, onClick, onMouseOver } : MenuCategoryProps) : JSX.Element => {
  const classes = useStyles();
  const { selectedLink } = useSelectedLinkContext();
  const alt = useFormatMessage({ id: altId });
  return (
    <Grid className={classes.menuCategory} item md={md} xs={12}>
      <Image
        className={classes.image}
        alt={alt}
        src={image}
        width='100%'
        onClick={enableEvenIfNoSelectedLink || selectedLink ? onClick : undefined}
        onMouseOver={onMouseOver}
      />
      {children}
    </Grid>
  );
}

export default MenuCategory;